import React, { useState, useEffect } from "react";
import Sidenavbar from "../Sidenavbar";
import Topbar from "../Topbar";
import "../../styles/CommonStyle.scss";
import "../../styles/Claims.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AccessDenied from "../../AccessDenied";
import ClaimManagerOutStation from "./ClaimManagerOutStation";
import ClaimAdminOutStation from "./ClaimAdminOutStation";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";

function OutStationClaim() {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  let loginDetails = JSON.parse(sessionStorage.getItem("usrlgndtls"));
  const twoLevelClaim = loginDetails?.subscription?.twoLevelClaim;
  const loggedInRole = loginDetails?.desingation?.role?.roleID;

  const [menuCollapse, setMenuCollapse] = useState(false);
  const [toggleshift, setToggleshift] = useState({ style: "" });

  const toggleMenu = () => {
    if (menuCollapse) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Page navigation
  const Navigate = useNavigate();
  const goToBackPage = () => {
    Navigate(-1);
  };
  // page navigation

  return (
    <div id="main-page">
      {userDetails !== null && userDetails !== "" ? (
        <>
          {/* SIDEBAR START */}
          <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />

          {/* TOPBAR START */}
          <Topbar
            toggleMenu={toggleMenu}
            menuCollapse={menuCollapse}
            toggleshift={toggleshift}
          />
          {/* TOPBAR END */}

          {/* MAIN BODY START */}
          <div className="page-wrapper">
            {/* PAGE CONTENT START */}

            <div className={`main-body ${toggleshift.style}`}>
              <div className="page-content">
                {/* USER TABLE START */}
                <div className="claims-table">
                  <Tabs
                    defaultActiveKey="manager"
                    id="uncontrolled-tab-example"
                    className="local-claim-nav-tab"
                  >
                    <Tab
                      title={
                        <div className="back-btn" onClick={goToBackPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                      }
                    />
                    <Tab title="OUTSTATION CLAIMS" className="local-claim-head">
                      OUTSTATION CLAIMS
                    </Tab>
                    <Tab eventKey="manager" title="Manager">
                      <ClaimManagerOutStation />
                    </Tab>
                    {twoLevelClaim === "Yes" && loggedInRole == 1 ? (
                      <Tab eventKey="admin" title="Admin">
                        <ClaimAdminOutStation />
                      </Tab>
                    ) : (
                      ""
                    )}
                  </Tabs>
                </div>
                {/* USER TABLE END */}

                {/* PAGE CONTENT END*/}
              </div>
            </div>
            {/* MAIN BODY END */}
          </div>
          <Footer />
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}

export default OutStationClaim;
